module.exports = __webpack_public_path__ + "3057783b9d2acd1337d4dafb5978bbee.png";